export const PRODUCTS_VIEW = { tile: 1, list: 2 }
export const PRODUCTS_VIEW_LIST = ['tile', 'list']
export const MENU_ARRANGEMENT_LIST = ['Regular', 'Trending']
export const PRODUCT_TYPES_LIST = ['For Here', 'To Go']
export const PRODUCTS_FILTER_LIST = [
	{
		label: 'All Products',
		value: 'all'
	},
	{
		label: 'New',
		value: 'new'
	},
	{
		label: 'Trending',
		value: 'Trending'
	},
	{
		label: 'Staff Favorites',
		value: 'favorite'
	}
]
export const PRODUCTS_FILTER_Values = {
	all: 'all',
	new: 'new',
	favorite: 'favorite'
}

export const WEBSOCKET_EVENT_TYPES = {
	1: 'TAB_CREATED',
	2: 'PAYMENT_SUCCESS',
	3: 'PAYMENT_FAILED',
	4: 'TAB_FAILED',
	5: 'TAB_CHANGED',
	6: 'CLOSED_AUTO_CLOSEOUT',
	7: 'EMAIL_CONFIRMATION'
}
export const CART_STATUS = {
	NEW: 1,
	TAB_CREATED: 2,
	PAYMENT_IN_PROGRESS: 3,
	PAYMENT_FAILED: 4,
	PAYMENT_SUCCESS: 5,
	RECEIPT_VIEWED: 6,
	CLOSED_AUTO_CLOSEOUT: 7,
	WAITING_POS: 21
}
export const HIDE_ERROR_DELAY = 3000

export const WEEK_DAYS = [
	{
		short: 'Sun',
		long: 'Sunday'
	},
	{
		short: 'Mon',
		long: 'Monday'
	},
	{
		short: 'Tue',
		long: 'Tuesday'
	},
	{
		short: 'Wed',
		long: 'Wednesday'
	},
	{
		short: 'Thu',
		long: 'Thursday'
	},
	{
		short: 'Fri',
		long: 'Friday'
	},
	{
		short: 'Sat',
		long: 'Saturday'
	}
]

export const FORCED_MODS_RULES = {
	UP_TO: 1,
	MUST_CHOOSE: 2
}

export const FORCED_MODS_TYPES = {
	FORCED_MOD: 1,
	NONE_FORCED: 2
}

export const REMAINING_STATUS = {
	UNLIMITED: 0,
	EIGHTY_SIX: 1,
	LIMIT_ALMOST_REACHED: 2,
	ALMOST_GONE: 3,
	LIMITED_QUANTITY: 4
}

export const CLASSIFICATION = {
	BEVERAGE: 1,
	FOOD: 2,
	RETAIL: 3
}

export const ORDER_LIMITATION_CONDITION = {
	DISABLED: 0,
	ORDER_HAS_AT_LIST_ONE_FOOD: 1,
	ORDER_HAS_AT_LIST_ONE_DRINK: 2
}

export const DEFAULT_UNAVAILABLE_MODAL_PROPS = {
	actionText: '',
	action: () => {},
	orderType: '',
	availablePeriod: {},
	isLoading: false,
	darkTheme: true
}

export const DAYS_LIST = {
	1: 'Sunday',
	2: 'Monday',
	3: 'Tuesday',
	4: 'Wednesday',
	5: 'Thursday',
	6: 'Friday',
	7: 'Saturday'
}

export const SHORTED_DAYS_LIST = {
	1: 'Sun',
	2: 'Mon',
	3: 'Tue',
	4: 'Wed',
	5: 'Thu',
	6: 'Fri',
	7: 'Sat'
}

export const ORDER_TYPES = {
	isInVenue: 1,
	isPickUp: 3
}

export const PRODUCT_ORDER_TYPES = {
	forHere: 1,
	toGo: 2,
	pickUp: 3
}

export const PRODUCT_ORDER_TYPES_NAMES = {
	1: 'Dine In',
	2: 'To Go',
	3: 'Pickup'
}

export const ALL_ORDER_TYPES_NAMES = {
	forHere: 'Dine In',
	toGo: 'To Go',
	pickUp: 'Pickup',
	inVenue: 'Dine In'
}

export const ORDERS_ACTIONS_TEXT_LIST = {
	cancel: 'Cancel Order',
	removeToGo: 'Remove To Go',
	removeForHere: 'Remove Dine in',
	addAsToGo: 'Add as To Go',
	addAsForHere: 'Add as Dine in'
}

export const COUNTRY_CODE = '+1'

export const MIN_ORDER_AMOUNT = 2

export const MAX_PRODUCTS_COUNT = 25

export const PHONE_NUMBER_REGEX = /^(1|)?(\d{3})(\d{3})(\d{4})$/

export const PAYMENT_GATEWAY = {
	ANDROID_PAY_CARD: 'AndroidPayCard',
	APPLE_PAY_CARD: 'ApplePayCard',
	CREDIT_CARD: 'CreditCard'
}

export const PAYMENT_PROVIDER = {
	MAGENSA: 2
}

export const BUSINESS_DAYS_TO_ROWS = {
	2: 'eodMon',
	3: 'eodTue',
	4: 'eodWed',
	5: 'eodThu',
	6: 'eodFri',
	7: 'eodSat',
	1: 'eodSun'
}

export const DEFAULT_SWIPER_OPTIONS = {
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
	pagination: {
		el: '.swiper-pagination',
		clickable: true
	}
}

export const ALLOWED_TAGS = [
	'p',
	'span',
	'strong',
	'em',
	'b',
	'i',
	'u',
	'br',
	'hr',
	'ul',
	'ol',
	'li',
	'h1',
	'h2',
	'h3',
	'h4',
	'h5',
	'h6',
	'a',
	'img',
	'table',
	'tr',
	'td',
	'th',
	'code',
	'pre'
]

export const ALLOWED_ATTR = ['href', 'target', 'rel', 'style']

export const DATE_FORMATS = {
	fullWithNames: 'dddd, MMMM D',
	fullWithShortNames: 'ddd, MMM D',
	fullWithNamesWithYear: 'dddd, MMMM D, YYYY',
	fullWithNamesWithYearAndShortDayNumber: 'ddd, MMMM D, YYYY',
	backEndDateTime: 'YYYY-MM-DD HH:mm:ss',
	eventStartDate: 'dddd, MMMM D, YYYY',
	shortMonth: 'MMM',
	day: 'D'
}

export const TIME_FORMATS = {
	AMPM: 'h:mm A',
	hoursMinutes: 'h:mm',
	hours: 'h'
}

export const AMPM_FORMAT = TIME_FORMATS.AMPM

export const TIME_ZONE_FORMATS = {
	name: 'z'
}

export const AUTO_CLOSEOUT_TYPES = {
	END_DAY: 1,
	MINUTES: 2,
	AUTO_CLOSEOUT_TIME: 3
}

export const WEB_SOCKET_STATE = {
	connecting: 0,
	open: 1,
	closing: 2,
	closed: 3
}

export const WEB_SOCKET_CLOSE_PREVIOUS_CONNECTION_CODE = 4000
export const WEB_SOCKET_CLOSE_PREVIOUS_CONNECTION_TEXT =
	'closed previous connection'

export const WebsocketStringMessage = {
	ping: '_ping',
	pong: '_pong'
}

export const VALIDATION_MESSAGES = {
	TICKET_ORDER_NOT_FOUND: 45001,
	TICKET_ORDER_PAYMENT_NOT_IN_PROGRESS: 45002,
	TICKET_ORDER_PAYMENT_IN_PROGRESS: 45003,
	TICKET_ORDER_RESERVED: 45004,
	TICKET_ORDER_PAID: 45005,
	TICKET_ORDER_NOT_PURCHASED: 45006,
	EVENT_NOT_FOUND: 45007,
	EVENT_STATUS_NOT_ACTIVE: 45008,
	USER_NOT_FOUND: 45009,
	VENUE_NOT_FOUND: 45010,
	VENUE_NOT_SUPPORT_PICKUP: 45011,
	VENUE_NOT_SUPPORT_TO_GO: 45012,
	CREDIT_CARD_NOT_FOUND: 45013,
	CREDIT_CARD_REACHED_MAXIMUM_LIMIT: 45014,
	CREDIT_CARD_NOT_VALID: 45015,
	CREDIT_CARD_NOT_VALID_EXP_DATE: 45016,
	CART_NOT_FOUND: 45017,
	CART_ALREADY_WAS_UPDATED: 45018,
	CART_EXPIRED: 45019,
	CART_SENT_TO_TAB: 45020,
	CART_NOT_ACTIVE: 45021,
	CART_UTENSILS_IN_ORDER: 45022,
	PRODUCT_NOT_FOUND: 45023,
	PRODUCTS_NOT_DELETED: 45024,
	CART_ITEM_SENT_TO_TAB: 45025,
	CART_ITEM_CART_NOT_ACTIVE: 45026,
	UTENSILS_CAN_INCLUDED: 45027,
	UTENSILS_NOT_AVAILABLE_FOR_TO_GO: 45028,
	UTENSILS_NOT_AVAILABLE_FOR_PICKUP: 45029,
	QR_CODE_NOT_FOUND: 45030,
	PHONE_CONFIRMED: 45031,
	PHONE_NOT_CONFIRMED: 45032,
	TICKETS_NOT_FOUND: 45033,
	LOCATION_REQUIRED_TO_MAKE_ORDER: 45034,
	PHONE_NUMBER_REQUIRED_TO_PICKUP: 45035,
	CUSTOMER_NAME_REQUIRED_TO_PICKUP: 45036,
	PICKUP_TIME_REQUIRED: 45037,
	PICKUP_TIME_NOT_UPDATED: 45038,
	PHONE_NUMBER_REQUIRED_TO_ORDERS: 45039,
	EMAIL_REQUIRED_TO_ORDERS: 45040,
	REQUEST_TO_OPEN_TAB_ALREADY_SENT: 45041,
	VENUE_NOT_SUPPORT_ACCEPTING_ONLINE_ORDERS: 45042,
	CART_ONE_OR_MORE_MODIFIERS_ARE_INVALID: 45043,
	CART_PRODUCT_NOT_HAVE_MODIFIERS: 45044,
	CART_PRODUCT_SOLD_OUT: 45045,
	CART_PRODUCT_NOT_HAVE_FORCED_MODS: 45046,
	CART_ONE_OR_MORE_FORCED_MODS_NOT_BELONG_TO_MOD_GROUP: 45047,
	CART_FORCED_MODS_CHOSEN_INCORRECTLY: 45048,
	CART_ITEM_INVALID: 45049,
	CART_NOT_POSSIBLE_TO_EDIT_ORDER: 45050,
	CART_FOR_HERE_NOT_AVAILABLE: 45051,
	CART_TO_GO_NOT_POSSIBLE: 45052,
	CART_DINE_IN_NOT_AVAILABLE: 45053,
	CART_PICKUP_NOT_POSSIBLE: 45054,
	CART_ORDER_HAS_AT_LIST_ONE_FOOD: 45055,
	CART_ORDER_HAS_AT_LIST_ONE_DRINK: 45056,
	QUANTITY_UNAVAILABLE_TRY_AGAIN_LATER: 4021
}

export const OPEN_TAB_VALIDATION_CODES = [
	VALIDATION_MESSAGES.VENUE_NOT_FOUND,
	VALIDATION_MESSAGES.CREDIT_CARD_NOT_FOUND,
	VALIDATION_MESSAGES.LOCATION_REQUIRED_TO_MAKE_ORDER,
	VALIDATION_MESSAGES.PHONE_NUMBER_REQUIRED_TO_PICKUP,
	VALIDATION_MESSAGES.CUSTOMER_NAME_REQUIRED_TO_PICKUP,
	VALIDATION_MESSAGES.PICKUP_TIME_REQUIRED,
	VALIDATION_MESSAGES.PHONE_NUMBER_REQUIRED_TO_ORDERS,
	VALIDATION_MESSAGES.EMAIL_REQUIRED_TO_ORDERS,
	VALIDATION_MESSAGES.REQUEST_TO_OPEN_TAB_ALREADY_SENT,
	VALIDATION_MESSAGES.CART_NOT_POSSIBLE_TO_EDIT_ORDER,
	VALIDATION_MESSAGES.CART_ORDER_HAS_AT_LIST_ONE_FOOD,
	VALIDATION_MESSAGES.CART_ORDER_HAS_AT_LIST_ONE_DRINK
]

export const UPDATE_CART_ITEM_404_VALIDATION_CODES = [
	VALIDATION_MESSAGES.CART_EXPIRED,
	VALIDATION_MESSAGES.VENUE_NOT_FOUND,
	VALIDATION_MESSAGES.CART_NOT_FOUND,
	VALIDATION_MESSAGES.CART_ITEM_INVALID
]

export const UPDATE_CART_ITEM_400_VALIDATION_CODES = [
	VALIDATION_MESSAGES.PRODUCT_NOT_FOUND,
	VALIDATION_MESSAGES.CART_ITEM_SENT_TO_TAB,
	VALIDATION_MESSAGES.CART_ITEM_CART_NOT_ACTIVE,
	VALIDATION_MESSAGES.CART_NOT_POSSIBLE_TO_EDIT_ORDER
]

export const SKIPPED_MESSAGES_CODES = [
	VALIDATION_MESSAGES.CART_NOT_FOUND,
	VALIDATION_MESSAGES.TICKET_ORDER_NOT_FOUND,
	VALIDATION_MESSAGES.EVENT_NOT_FOUND,
	VALIDATION_MESSAGES.USER_NOT_FOUND,
	VALIDATION_MESSAGES.VENUE_NOT_FOUND,
	VALIDATION_MESSAGES.CART_EXPIRED,
	VALIDATION_MESSAGES.CART_NOT_ACTIVE,
	VALIDATION_MESSAGES.EVENT_STATUS_NOT_ACTIVE
]

export const GOOGLE_PAY_SKIPPED_ERROR = 'User closed the Payment Request UI.'

export const KEYS = {
	dot: '.',
	coma: ',',
	enter: 'Enter'
}

export const KEYS_CODE = {
	backSpace: 8,
	androidNumericComa: 229
}
